import { z } from "zod";
import { rankingDecisionSchema } from "./ranking-decision.contract.ts";

export const searchCallerSurfaceSchema = z.enum(["web", "kits", "api"]);
export const searchParseTriggerSchema = z.enum(["debounce", "submit", "api"]);

export const searchInteractionContextSchema = z.object({
    searchInteractionId: z.uuid(),
    queryRevision: z.number().int().nonnegative(),
    parseId: z.uuid().optional(),
});

export const searchParseContextSchema = searchInteractionContextSchema.extend({
    parseId: z.uuid(),
    surface: searchCallerSurfaceSchema,
    trigger: searchParseTriggerSchema,
});

export const searchSubmissionContextSchema =
    searchInteractionContextSchema.extend({
        submissionId: z.uuid(),
    });

export const searchExecutionOperationSchema = z.enum([
    "results",
    "count",
    "page",
]);

export const searchExecutionTargetSchema = z.enum([
    "listings",
    "organizations",
]);

export const searchExecutionContextSchema =
    searchSubmissionContextSchema.extend({
        rankingDecision: rankingDecisionSchema.optional(),
        executionId: z.uuid(),
        operation: searchExecutionOperationSchema,
        target: searchExecutionTargetSchema,
        intentIndexes: z.array(z.number().int().nonnegative()).min(1).max(3),
        page: z.number().int().nonnegative(),
        pageSize: z.number().int().positive(),
    });

export const searchSubmissionSourceSchema = z.enum([
    "parsed",
    "keyword_fallback",
    "dog_name_fallback",
    "phrase",
    "breed",
    "recent",
    "starter",
    "filters",
    "url",
    "api",
]);

export const searchTerminalActionSchema = z.enum([
    "enter",
    "submit_button",
    "intent_option",
    "suggestion",
    "filter_change",
    "navigation",
    "api",
]);

export const searchTerminalContextSchema = searchSubmissionContextSchema.extend(
    {
        query: z.string().max(1_000),
        submissionSource: searchSubmissionSourceSchema,
        action: searchTerminalActionSchema,
        surface: searchCallerSurfaceSchema,
    },
);

export const searchResultEntitySchema = z.object({
    entityType: z.enum(["listing", "organization"]),
    entityId: z.string().min(1),
    rank: z.number().int().nonnegative(),
    intentIndexes: z.array(z.number().int().nonnegative()).min(1).max(3),
});

export type SearchInteractionContext = z.infer<
    typeof searchInteractionContextSchema
>;
export type SearchParseContext = z.infer<typeof searchParseContextSchema>;
export type SearchSubmissionContext = z.infer<
    typeof searchSubmissionContextSchema
>;
export type SearchExecutionContext = z.infer<
    typeof searchExecutionContextSchema
>;
export type SearchTerminalContext = z.infer<typeof searchTerminalContextSchema>;
